<template>
  <Dialog ref="savingDialog" panelClass="bui-dialog-panel">
    <template #expander>
      <ButtonCustomized
        label="Save"
        @click="saveSlide"
        :disabled="!hasUnsavedChanges"
      />
    </template>
    <template #dialog.title>Saving</template>
    <template #dialog.content>
      <div class="saving-progress-dialog-content">
        <!-- TODO: think about adding height option for StatusBar — N2LBs3CL -->
        <StatusBar
          :errorMessage="errorMessage"
          :isLoading="isLoading"
          loadingMessage="Saving..."
          :isSuccess="isSuccess"
          successMessage="Saved!"
        />
      </div>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import ButtonCustomized from '@/components/form-fields/ButtonCustomized.vue';
import Dialog from '@/components/Dialog/Dialog.vue';
import StatusBar from "@/components/form-fields/StatusBar/StatusBar.vue";
import useSaveCurrentSlide from './composables/saveCurrentSlide';
import useNotifications from '@/components/Notifications/composables/notifications';
import useSlide from '@/views/MediaEditorView/SlideEditor/composables/slide';
import { ref } from 'vue';

defineExpose({
  saveSlide,
})

const { submitSaveCurrentSlide, isSuccess, errorMessage, isLoading } = useSaveCurrentSlide();
const { hasUnsavedChanges, unsetHasUnsavedChanges } = useSlide();

const notification = useNotifications();

const savingDialog = ref();

async function saveSlide() {
  savingDialog.value.openModal();
  await submitSaveCurrentSlide();
  const successNotificationMessage = 'Slide saved successfuly!';
  if(isSuccess.value === true) {
    notification.success(successNotificationMessage);
    unsetHasUnsavedChanges({resetDataInitializationState: false});
    savingDialog.value.closeModalAfter(1000);
  } else {    // on failure
    // TODO: add error notiofication — N2LEbC6N
  }
}
</script>

<style lang="scss" scoped>
.saving-progress-dialog-content {
  min-height: 60px;
  min-width: 300px;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
}
</style>